import z from "zod";

export const formSchema = z.object({
  invoiceModuleEnabled: z.boolean(),
});
